<template>
  <div class="summary resources__page-topic">
    <div v-if="activeEntry" class="resources__top-wrap">
      <release-details :activeEntry="activeEntry" :pageType="cPage?.fields?.pageType" />
    </div>
    <div v-else>
      <div class="resources__top-wrap">
        <RichRenderer :richTextData="cPage?.fields?.paragraphRich" />
      </div>
      <div class="summary__items-wrapper">
        <div
          v-for="(item, n) in entries"
          :key="item.title + n"
          class="summary__item"
          @click="entryClicked(item)"
        >
          <div v-if="item.date" class="summary__date-wrapper">
            <div class="summary__date-month" v-html="getMonth(item.date)" />
            <div class="summary__date-day" v-html="getDay(item.date)" />
          </div>
          <div class="summary__copy-wrapper">
            <h4 class="text-h4 text-color-navy resources__copy-title" v-html="item.title" />
            <RichRenderer :richTextData="item.description" />
            <div v-if="item.date" class="summary__period">
              <span class="text-link" v-html="getFullDate(item.date)" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { onMounted, ref, watch } from 'vue'
import { useRouter } from 'vue-router'

import dayjs from '@/lib/utils/dayjs'

import { useContentfulComponent } from '@/components/common/contentful/composables/useContentfulComponent'

import ReleaseDetails from '@/components/resources/pages/ReleaseDetails.vue'

import { useErrorService } from '@/composables/useErrorService'
import { usePageMeta } from '@/composables/usePageMeta'
import { useTransformEntries } from '@/composables/useTransformEntries'

export default {
  name: 'ReleaseSummary',
  components: {
    ReleaseDetails,
  },
  props: {
    cPage: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { fetchItems } = useContentfulComponent()
    const { setPageMeta } = usePageMeta()
    const errorService = useErrorService()
    const { transformEntries } = useTransformEntries()
    const router = useRouter()

    const entries = ref([])
    const activeEntry = ref(null)

    const setEntry = () => {
      activeEntry.value = entries.value.find(
        (el) => el.title === router.currentRoute.value.query.entry,
      )
    }

    const initData = async (contentfulEntries) => {
      entries.value = transformEntries(contentfulEntries)
      setEntry()
    }

    const entryClicked = (entry) => {
      router.push({
        path: router.currentRoute.value.path,
        query: { entry: entry.title },
      })
    }

    const getMonth = (date) => {
      return dayjs(date).format('MMM')
    }

    const getDay = (date) => {
      return dayjs(date).format('DD')
    }

    const getFullDate = (date) => {
      return dayjs(date).format('LL')
    }

    setPageMeta(props.cPage?.fields?.pageMeta)

    watch(
      () => router.currentRoute.value,
      () => {
        setEntry()
      },
    )

    onMounted(async () => {
      const query = {
        skip: 0,
        limit: 1000,
        include: 1,
        order: '-fields.date,sys.createdAt',
        content_type: 'resource',
        'fields.resourceGroup.sys.id': props.cPage.sys.id,
      }
      const contentfulEntries = await fetchItems(query)
      if (!contentfulEntries) {
        const error = new Error('No contentful entry on Resource request')
        errorService.decorateError('CONTENTFUL', error, { errorLevel: 'network' })
        throw error
      } else {
        initData(contentfulEntries)
      }
    })

    return {
      entries,
      activeEntry,
      entryClicked,
      getMonth,
      getDay,
      getFullDate,
    }
  },
}
</script>
